import React from "react";
import PlaceholderBooking from 'placeholders/PlaceholderBooking';
import PlaceholderContainer from 'placeholders/PlaceholderContainer';
import { StyleSheet, View } from "react-native";
import _ from 'lodash';
import HelperString from 'utils/helper-string'
import { Placeholder, PlaceholderMedia } from 'placeholders/Placeholder'

const PlaceholderCalendarStrip = ({ containerStyle = {} }) => {
	
	const items = [ 1, 2, 3, 4, 5, 6, 7 ];
	
	return (
		<PlaceholderContainer style={ containerStyle }>
			<Placeholder>
				<View
					style={ styles.container }>
					
					{ _.map( items, item => {
						return (
							<View
								key={ HelperString.hash( 'placeholder', item ) }
								style={ styles.item }>

								<PlaceholderMedia
									size={ 30 }
									isRound={ true }>

									{ item }
								</PlaceholderMedia>
							</View>
						);
					})}
				</View>
			</Placeholder>
			
			<PlaceholderBooking />
		</PlaceholderContainer>
	)
}

const styles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		justifyContent: 'center'
	},
	item: {
		margin: 8,
	}
});

export default PlaceholderCalendarStrip
